import { db } from "./firebaseConfig";
import { doc, updateDoc } from "firebase/firestore";


const DataUpdate = async ({idDoc,collection, ObjValues}) => {
    const documento = doc(db, collection, idDoc);
    return await updateDoc(documento, ObjValues);
}

export default DataUpdate;